import * as React from "react";

import {
  DefaultValuesDetailsForm,
  DetailsFormValues,
} from "../WebCheckInForms/WebCheckInForms.props";

import { AppInputSwitchProps } from "../AppInputSwitcher/AppInputSwitcher.props";
import { AppInputSwitcher } from "../AppInputSwitcher/AppInputSwitcher";
import { DriverFormFields } from "../WebCheckInForms/FormKeys";
import { DriverFormProps } from "./DriverFormProps";
import { FormFieldErrorMessage } from "../../UI/FormFieldErrorMessage/FormFieldErrorMessage";
import { ReadOnlyIfInitialValuesNotProvided } from "../WebCheckInForms/FormOptions";
import { RegisterOptions } from "react-hook-form/dist/types/validator";
import { useTranslation } from "react-i18next";
import { useWebCheckInForm } from "../../../hooks/DriverWebCheckInForm";
import { AddDocumentsWithPreview } from "../../UI/AllWebCheckInForms/DocumentUpload";
import BookingGetters from "../../../store/onlineBooking/getters";

export function DriverAddForm({
  driverDetails = {},
  initialValues = { ...DefaultValuesDetailsForm },

  onChange = () => {},
  onSubmit = () => {},
  children = <></>,
  documentTypes,
}: DriverFormProps) {
  const [
    {
      register,
      handleSubmit,
      formState: { errors },
      getValues,
      setValue,
    },
    driverFormFields,
  ] = useWebCheckInForm(
    DriverFormFields,
    {
      ...Object.keys(driverDetails).reduce((prevValue, currentKey) => {
        prevValue[currentKey] = initialValues[currentKey]
          ? initialValues[currentKey]
          : driverDetails[currentKey] || DefaultValuesDetailsForm[currentKey];

        return prevValue;
      }, {}),
    } as DetailsFormValues,
    (e) => {
      onChange({ ...DefaultValuesDetailsForm, ...e });
    }
  );
  const { t: translate } = useTranslation();
  const handleCountryChange = (newCountryValue) => {
    setValue("country", newCountryValue || "");
    setValue("city", "");
    setValue("state", "");
  };
  const requiredFields = ["firstName", "lastName"];
  const isSmallScreen = window.innerWidth <= 500;
  const appSettings = BookingGetters.getAppSettings();
  // is pre-selected regardless of the language it was stored in.
  const normalizeGender = (raw?: string | null): "" | "MALE" | "FEMALE" => {
    if (!raw) return "";
    const v = raw.toString().trim().toUpperCase();
    if (["M", "MALE", "MASCHIO", "MASCULINO", "HOMME"].includes(v)) {
      return "MALE";
    }
    if (["F", "FEMALE", "FEMMINA", "FEMININA", "FEMME"].includes(v)) {
      return "FEMALE";
    }
    return "";
  };

  React.useEffect(() => {
    const normalized = normalizeGender(getValues("sex") || initialValues.sex);
    if (normalized && getValues("sex") !== normalized) {
      setValue("sex", normalized);
    }
  }, []);
  return (
    <>
      <form
        onSubmit={handleSubmit((e) => {
          setTimeout(onSubmit, 1000, { ...driverDetails, ...e });
        })}
      >
        <div
          className={`grid gap-4 mt-2 ${isSmallScreen ? "" : "grid-cols-2"} `}
        >
          {Object.values(driverFormFields).map((el: AppInputSwitchProps) => {
            const isGenderField = el.key === "sex";
            const readOnly =
              el.readOnly ||
              (ReadOnlyIfInitialValuesNotProvided.includes(el.key) &&
                !!initialValues[el.key]);

            const options: RegisterOptions = {};
            if (requiredFields.includes(el.key) && !readOnly) {
              options.required = {
                value: true,
                message: translate("This is a required field"),
              };
            }
            if (appSettings?.driverEmailRequired && el.key === "email") {
              options.pattern = {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: translate("Please provide a valid email"),
              };
            }

            if (appSettings?.driverMidNameRequired && el.key === "middleName") {
              options.required = {
                value: true,
                message: translate("Please provide a middle Name"),
              };
            }

            if (appSettings?.driverCountryRequired && el.key === "country") {
              options.required = {
                value: true,
                message: translate("Please select a country Name"),
              };
            }
            if (appSettings?.driverCityRequired && el.key === "city") {
              options.required = {
                value: true,
                message: translate("Please provide a city Name"),
              };
            }
            if (appSettings?.driverStateRequired && el.key === "state") {
              options.required = {
                value: true,
                message: translate("Please provide a state Name"),
              };
            }

            if (appSettings?.driverZipCodeRequired && el.key === "zip") {
              options.required = {
                value: true,
                message: translate("Please provide zip code number"),
              };
            }
            if (
              appSettings?.driverStreetNameRequired &&
              el.key === "streetName"
            ) {
              options.required = {
                value: true,
                message: translate("Please provide a street Name"),
              };
            }
            if (
              appSettings?.driverStreetNoRequired &&
              el.key === "streetName"
            ) {
              options.required = {
                value: true,
                message: translate("Please provide a street Name"),
              };
            }

            if (appSettings?.driverPhoneNoRequired && el.key === "telephone") {
              options.required = {
                value: true,
                message: translate("Please provide phone number"),
              };
            }
            if (
              appSettings?.driverGenderRequired &&
              el.key === "sex" &&
              !readOnly
            ) {
              options.required = {
                value: true,
                message: translate("Please select a gender"),
              };
            }
            if (
              appSettings?.driverBirthNationRequired &&
              el.key === "birthNation"
            ) {
              options.required = {
                value: true,
                message: translate("Please provide a birth nation Name"),
              };
            }

            if (
              appSettings?.driverBirthDateRequired &&
              el.key === "dateOfBirth"
            ) {
              options.required = {
                value: true,
                message: translate("Please select birth date"),
              };
            }
            if (
              appSettings?.driverBirthPlaceRequired &&
              el.key === "birthPlace"
            ) {
              options.required = {
                value: true,
                message: translate("Please provide a birth place Name"),
              };
            }
            if (appSettings?.driverEmailRequired && el.key === "email") {
              options.required = {
                value: true,
                message: translate("Please provide a email"),
              };
              options.pattern = {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: translate("Email is invalid"),
              };
            }
            if (
              appSettings?.driverReleaseDateRequired &&
              el.key === "releaseDate"
            ) {
              options.required = {
                value: true,
                message: translate("Please select release date"),
              };
            }
            if (
              appSettings?.driverBirthProvRequired &&
              el.key === "birthProvince"
            ) {
              options.required = {
                value: true,
                message: translate("Please provide a birth provience Name"),
              };
            }

            if (
              appSettings?.driverLicenceTypeRequired &&
              el.key === "licenseType"
            ) {
              options.required = {
                value: true,
                message: translate("Please provide a licence"),
              };
            }
            if (
              appSettings?.driverExpiryDateRequired &&
              el.key === "documentExpiryDate"
            ) {
              options.required = {
                value: true,
                message: translate("Please provide expiry date"),
              };
            }
            if (appSettings?.driverIssueByRequired && el.key === "issueBy") {
              options.required = {
                value: true,
                message: translate("Please provide issued name"),
              };
            }

            if (appSettings?.driverSSNRequired && el.key === "ssnNumber") {
              options.required = {
                value: true,
                message: translate("Please provide ssn number"),
              };
              options.minLength = {
                value: 16,
                message: translate("Please provide a valid SSN"),
              };
              options.maxLength = {
                value: 16,
                message: translate("Please provide a valid SSN"),
              };
            }
            if (appSettings?.driverDocumentRequired && el.key == "document") {
              options.required = {
                value: true,
                message: translate("Please provide document name"),
              };
            }
            const translatedGenderValue = isGenderField
              ? normalizeGender(getValues(el.key) || initialValues.sex)
              : el.key === "document" && readOnly && getValues(el.key)
              ? translate(getValues(el.key))
              : getValues(el.key) || "";

            const fieldOptions = isGenderField
              ? [
                  { label: translate("MALE"), value: "MALE" },
                  { label: translate("FEMALE"), value: "FEMALE" },
                ]
              : el.options || [];

            return (
              <div className="w-full h-full" key={el.key}>
                <AppInputSwitcher
                  {...el}
                  {...register(el.key, {
                    ...options,
                  })}
                  required={false}
                  onChange={() => {}}
                  // className={"h-[80px]"}
                  // label={translate(el.label || "")}
                  label={
                    <>
                      {translate(el.label || "")}
                      {requiredFields.includes(el.key) && (
                        <span style={{ color: "red" }}> *</span>
                      )}
                    </>
                  }
                  readOnly={readOnly}
                  placeholder={translate(el.placeholder || "")}
                  /* options={el.options || []}*/
                  value={translatedGenderValue}
                  options={fieldOptions}
                  // options={
                  //   el.key === "sex"
                  //     ? [translate("MALE"), translate("FEMALE")]
                  //     : el.options || []
                  // }
                  // value={
                  //   genderMap[getValues(el.key)]?.[i18n.language] ||
                  //   getValues(el.key) ||
                  //   ""
                  // }
                  onchange={(e) => {
                    if (el.key == "country") {
                      handleCountryChange(e);
                    }
                    setValue(el.key, e, {
                      shouldValidate: true,
                    });
                  }}
                />
                <FormFieldErrorMessage>
                  {errors[el.key]?.message}
                </FormFieldErrorMessage>
              </div>
            );
          })}
        </div>
        {children}
      </form>
    </>
  );
}
